const eventsRetentionNames = {
	popupShown: 'modal_window_show',
	popupCTAClicked: 'modal_window_click',
};

export default eventsRetentionNames;
